import { ReactNode } from 'react';
import styles from './ViewSwitch.module.scss';
import { ViewType } from '../../../../lib/types/aemDataModels';
import { GridIcon } from '../../../../lib/icons/GridIcon';
import { ListIcon } from '../../../../lib/icons/ListIcon';
import { classes } from '../../../../lib/utils/cssUtils';
import { Label } from '../../../common/Label/Label';
import { FILTER_LABELS } from '../../../../lib/constants/labelKeys';

export type ViewSwitchProps = {
  selected: ViewType;
  onSelect: (viewType: ViewType) => void;
};

const ViewSwitch = ({ selected, onSelect }: ViewSwitchProps): ReactNode => (
  <div className={styles.wrapper}>
    <button
      className={classes(styles.containerBase, { [styles.active]: selected === 'list' })}
      onClick={() => onSelect('list')}
      role="switch"
      aria-checked={selected === 'list'}
    >
      <ListIcon className={styles.icon} /> <Label name={FILTER_LABELS.VIEW_SWITCH_LABEL('list')} />
    </button>
    <button
      className={classes(styles.containerBase, { [styles.active]: selected === 'grid' })}
      onClick={() => onSelect('grid')}
      role="switch"
      aria-checked={selected === 'grid'}
    >
      <GridIcon className={styles.icon} /> <Label name={FILTER_LABELS.VIEW_SWITCH_LABEL('grid')} />
    </button>
  </div>
);

export default ViewSwitch;
